import { graphql } from 'react-relay';

export default graphql`
  query CeoPage_Query {
    viewer {
      id
      ...CeoPage_viewer
    }
  }
`;
